<template>
  <div class="row global_box position-relative">
   <div class="col-xl-4 col-lg-4 col-md-6 box_rmk qh-mb" uk-scrollspy="cls: uk-animation-slide-left; repeat: false; delay: 0;" v-for="box in this.getBox_list" :key="box.id">  
        <!-- <pizza :boxdata="box"></pizza> -->
        <!-- <component :is="'pizza'" :boxdata="box"></component> -->
        <!-- {{box.id}} -->
        <!-- {{box.type}} -->
         <component v-if="!$store.state.skelton" :is="box.type" :boxdata="box" :setting="get_setting_app"></component>
    </div>
     <!-- skellton loader -->
     <div v-if="$store.state.skelton"> 
       <!--  -->
       <div class="skellton row" >
         <div class="col-xl-4 col-md-6 mb-4"  v-for="num in repeat" :key="num">
        <section >
        <b-skeleton  width="20%" :animated="animated"></b-skeleton>

        <b-skeleton  width="40%" :animated="animated"></b-skeleton>

        <b-skeleton  width="80%" :animated="animated"></b-skeleton>

        <b-skeleton :animated="animated"></b-skeleton>

    </section>
         </div>
       </div>
         </div>
  </div>
</template>

<script>
import {mapGetters , mapActions} from 'vuex';
import pizza from '@/components/meny/pizza';
import half_half from '@/components/meny/half_half';
import other from '@/components/meny/other';
import other_comp from '@/components/meny/other_comp';
import multi_product from '@/components/meny/multi_product';
import kebab from '@/components/meny/kebab';
import burger from '@/components/meny/burger';
import entrees from '@/components/meny/entrees';
// component sub
export default {
  name: "menyboxApp",
  components:{pizza,half_half , other , other_comp , multi_product , kebab , burger , entrees },
  data: function () {
    return {
      animated: true,
      repeat:14
    };
  },
  methods: {
    ...mapActions({
      getboxCategory_Api:'getboxCategory_Api',
       getCategoryMenu_Api:'getCategoryMenu_Api',
       change_category_by_name:'change_category_by_name'
    })
  },
  computed:{
     ...mapGetters({
       getBox_list:'getBox_list',
       get_setting_app:'get_setting_app'
     })
  },
     watch: {
        // parameters to
        '$route': function(to) {
          console.log('route is change', to.name);
          if(to.name =='Meny'){
            console.log(to)
          }
           this.change_category_by_name(this.$route.params.name);
        }
      },
    mounted: function () {
      console.log(this.$route.params.name ,);
      this.getCategoryMenu_Api();  
      if(this.$route.params.name){
    this.change_category_by_name(this.$route.params.name);
      }
      else{
         this.getboxCategory_Api().then(()=>{
      });
      }
  },
};
</script>





<style scoped lang="scss">
.skellton{
   position: absolute;
    top: -4px;
    left: 10px;
    width: 100%;
}
</style>

 <!-- <div class="flex_spicy">
            <span v-for="spi in  box.spicy" :key="spi.id">
              <img :data-src="spi.icon" uk-img alt="">
            </span>
          </div> -->

 